import api from 'api'
import { FormCreation } from 'contexts/CampaignFormContext'
import { CreationFile } from 'types/campaign'
import { CardStatus } from 'components/Layout/Card/types'
import CreationThumbnailVertical from 'images/creation-thumbnail-vertical.svg'
import CreationThumbnailZip from 'images/creation-thumbnail-zip.svg'
import { ModalUploadFile } from 'components/Modal/ModalUpload'
import { voohCampaignFormActions } from '../../VoohCampaignForm/slice'
import { VoohMediaFormat } from '../../VoohCampaignForm/types'
import { store } from '../../../../store'
import { campaignFormActions } from '../../../Campaign/store/campaign-form-slice'
import { DEFAULT_CREATION_DURATION } from '../../../../constant'

export default class VoohCreationsUploadService {
  static handleSubmit = (
    voohCampaignId: string,
    details: string,
    uploadedFiles: ModalUploadFile[],
    hourFrequency: number,
    setLoading: (isLoading: boolean) => void,
    onFinish: () => void,
    mediaDuration?: number | null
  ): void => {
    setLoading(true)
    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVING }))

    api.voohCreation
      .createVoohCreations({
        voohCampaignId,
        details,
        mediaFormat: VoohMediaFormat.MOVE_TV,
        files: uploadedFiles,
        duration: mediaDuration ? mediaDuration : DEFAULT_CREATION_DURATION,
        hourFrequency,
      })
      .then(res => {
        if (!res.data) {
          store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.NONE }))
          return
        }
        store.dispatch(
          voohCampaignFormActions.setVoohCampaignPublishable(
            res.data.createVoohCampaignCreations.voohCampaign.publishable
          )
        )

        store.dispatch(
          voohCampaignFormActions.addCreations(
            res.data.createVoohCampaignCreations.voohCreations.map(creation => {
              return {
                id: creation.id,
                createdAt: new Date().toString(),
                archiveReason: creation.archiveReason,
                thumbnailUrl: VoohCreationsUploadService.generateThumbnailURL(
                  creation.file!.isVideo,
                  creation.file!.mimeType,
                  VoohCreationsUploadService.findUploadedFileByName(
                    uploadedFiles,
                    creation.file!.filename
                  )!.preview
                ),
                file: creation.file,
                duration: creation.duration,
                schedules: creation.schedules,
                filename: creation.file?.filename,
                details,
                hourFrequency: creation.hourFrequency,
                mediaFormat: creation.mediaFormat,
              }
            })
          )
        )
      })
      .catch(
        () =>
          void store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      )
      .finally(() => {
        setLoading(false)
        store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
        onFinish()
      })
  }

  static findUploadedFileByName = (
    uploadedFiles: ModalUploadFile[],
    searchedName: ModalUploadFile['name']
  ): ModalUploadFile | undefined =>
    uploadedFiles.find((f: ModalUploadFile) => f.name === searchedName)

  static generateThumbnailURL = (
    isVideo: CreationFile['isVideo'],
    mimeType: CreationFile['mimeType'],
    filePreview: ModalUploadFile['preview']
  ): FormCreation['thumbnailUrl'] => {
    let thumbnailUrl
    if (isVideo) {
      thumbnailUrl = CreationThumbnailVertical
    } else if (mimeType === 'application/zip') {
      thumbnailUrl = CreationThumbnailZip
    } else {
      thumbnailUrl = filePreview
    }

    return thumbnailUrl
  }
}
